import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Layout } from '../Layout/Layout';
import Header from '../Header/Header';
import EditNoteIcon from '@mui/icons-material/EditNote';
import GradingIcon from '@mui/icons-material/Grading';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import Create from './Steps/Create';
import SelectCompetencies from './Steps/SelectCompetencies';
import AddRaterGroups from './Steps/AddRaterGroups';
import { useFormik } from 'formik';
import AddSubjects from './Steps/AddSubjects';
import AddRaters from './Steps/AddRaters';
import SendToOrg from './Steps/SendToOrg';
import SendToSubjects from './Steps/SendToSubjects';
import * as yup from 'yup';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';

const steps = ['Create Assessment', 'Select Competencies', 'Add Rater Groups', 'Add Subjects', 'Add Raters', 'Send Assessment'];

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        // backgroundImage:
        //   'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
        backgroundColor: '#3fa8c6',
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        // backgroundImage:
        //   'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
        backgroundColor: '#3fa8c6',
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 3,
      border: 0,
      backgroundColor:
        theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
      borderRadius: 1,
    },
  }));
  
  const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
      // backgroundImage:
      //   'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
      backgroundColor: '#3fa8c6',
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
    ...(ownerState.completed && {
      // backgroundImage:
      //   'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
      backgroundColor: '#3fa8c6',
    }),
  }));
  
  function ColorlibStepIcon(props) {
    const { active, completed, className } = props;
  
    const icons = {
      1: <EditNoteIcon />,
      2: <GradingIcon />,
      3: <GroupAddIcon />,
      4: <PlaylistAddIcon />,
      5: <ControlPointIcon />,
      6: <ForwardToInboxIcon />,
    };
    return (
      <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
        {icons[String(props.icon)]}
      </ColorlibStepIconRoot>
    );
  }

const validationSchema = yup.object().shape({
  // name: yup.string().required('Name is required'),
  name: yup.string().when('templateType', {
    is: (val) => val === 'Manual',
    then: (schema) => schema.required('Assessment Name is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  team: yup.object().required("Organization is required!"),
  emailTemplate: yup.object().required("Email Template is required!"),
  scalePoint: yup.string().required('Scale Point is required'),
  measurementType: yup.string().required('Measurement Type is required'),

  templateType: yup.string().required('Template type is required'),
  // template: yup.string('').required('Template is required'),
  template: yup.string().when('templateType', {
      is: (val) => val === 'Default',
      then: (schema) => schema.required('Template is required'),
  }),
  questions: yup.array().when('templateType', {
      is: (val) => val === 'Manual',
      then: (schema) => schema.min(1, 'At least one question is required'),
  }),
  raterGroups: yup.array().min(1, 'At least one rater group is required'),
  subjects: yup.array().of(yup.object(
    {
      raters: yup.array().min(1, 'At least one rater is required')
    }
  )).min(1, 'At least one subject is required'),
  logo1: yup.mixed().test(
    'logo-required',
    'Please upload a logo',
    function (value) {
      // edit case (string URL)
      if (typeof value === 'string' && value.trim() !== '') return true;

      // new upload
      if (value instanceof File) return true;

      console.log("value",value);
      
      return false;
    }
  )
});

export default function CreateAssessment() {
  const { assessmentId } = useParams();
  const [activeStep, setActiveStep] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isErrorNoOfRaterGroup, setIsErrorNoOfRaterGroup] = React.useState(false);
  const navigate = useNavigate();
  // const [skipped, setSkipped] = React.useState(new Set());

  // const isStepOptional = (step) => {
  //   return step === 1;
  // };

  // const isStepSkipped = (step) => {
  //   return skipped.has(step);
  // };

  React.useEffect(() => {
    validateRaters()
  }, [])
  
  React.useEffect(() => {
    getDetails()
  }, [assessmentId])

  const getDetails = async () => {
    await axios.get(`/api/assessment?id=${assessmentId}`)
    .then(function (response) {
        let result = response.data;
        if(result.success && result.data?.id){
          formik.setFieldValue('id', result.data?.id)
          formik.setFieldValue('name', result.data?.name)
          formik.setFieldValue('team', result.data?.team)
          formik.setFieldValue('emailTemplate', result.data?.email_template || null)
          formik.setFieldValue('scalePoint', result.data?.scalePoint || '')
          formik.setFieldValue('measurementType', result.data?.measurementType || '')
          formik.setFieldValue('templateType', result.data?.templateType)
          formik.setFieldValue('template', result.data?.surveyId)
          formik.setFieldValue('questions', result.data?.questions)
          formik.setFieldValue('survey', result.data?.assessment_survey)
          formik.setFieldValue('raterGroups', result.data?.raterGroups)
          formik.setFieldValue('subjects', result.data?.subjects)
          formik.setFieldValue('logo1', result.data?.logo1)
          // formik.setFieldValue('logo2', result.data?.logo2 || null)
          // formik.setFieldValue('logo3', result.data?.logo3 || null)
        }
        setIsLoading(false)
    })
}

  const formik = useFormik({
    initialValues: {
      id: 0,
      name: '',
      team: null,
      emailTemplate: null,
      scalePoint: '',
      measurementType: '',
      templateType: '',
      template: '',
      survey: null,
      questions: [],
      raterGroups: [],
      raterGroupName: '',
      raterGroupRaters: 1,
      subjects: [
          // {id: 1, name: 'Shubham', email: 'shubham.tomar@actiknow.com', preferredPronoun: 'He'},
      ],
      subjectFirstName: '',
      subjectLastName: '',
      subjectEmail: '',
      subjectPreferredPronoun: null,
      subjectTitle: '',
      raterFirstName: '',
      raterLastName: '',
      raterEmail: '',
      raterGroup: null,
      logo1: '',
      // logo2: null,
      // logo3: null,
    },
    validationSchema: validationSchema,
    onSubmit: values => {
        console.log("Submit")
    },
  });

  const handleNext = async () => {
    setIsLoading(true)
    // let newSkipped = skipped;
    // if (isStepSkipped(activeStep)) {
    //   newSkipped = new Set(newSkipped.values());
    //   newSkipped.delete(activeStep);
    // }
    await formik.submitForm()
    console.log("formError",formik.errors)
    console.log("formValues",formik.values)
    if(activeStep === 0 && formik.values.team !== null && formik.values.emailTemplate !== null && formik.values.scalePoint && formik.values.measurementType && formik.values.logo1){      
      saveData()            
    }
    else if(activeStep === 1 && formik.values.templateType !== ''){
      if(formik.values.templateType === 'Default' && formik.values.template !== ''){
        saveData()
      }
      else if(formik.values.templateType === 'Manual' && formik.values.questions.length > 0 && formik.values.name !== ''){
        saveData()
      }
      else{
        setIsLoading(false)
      }
    }
    else if(activeStep === 2 && formik.values.raterGroups.length > 0){
      saveData()
    }
    else if(activeStep === 3 && formik.values.subjects.length > 0){
      saveData()
    }
    else if(activeStep === 4 && await validateRaters() === false){
      setIsErrorNoOfRaterGroup(false)
      saveData()
    }
    else{
      setIsLoading(false)
    }
    // setSkipped(newSkipped);
  };

  const checkRaters = (index) => {
    return new Promise((resolve)=>{
        let errorMsg = false
        if(formik.values.subjects[index]?.subject_raters){
            let raters = formik.values.subjects[index].subject_raters;
            let groups = {}
            for(let rater of raters){
                if(groups[rater.raterGroup.name]){
                    groups[rater.raterGroup.name] = groups[rater.raterGroup.name] + 1
                }
                else{
                    groups[rater.raterGroup.name] = 1
                }
            }
            // console.log("groups-------------------------", groups)
            let isManagerAdded = false
            let managers = {}

            let raterGroups = formik.values.raterGroups;

            for(let raterGroup of raterGroups){

              // validate only if min_one_rater = 1
              if(raterGroup.min_one_rater == 1){

                  let count = groups[raterGroup.name] ? groups[raterGroup.name] : 0

                  if(count < 1){
                      errorMsg = true
                  }

              }
              else{
                let count = groups[raterGroup.name] ? groups[raterGroup.name] : 0

                  if(count < 3){
                      errorMsg = true
                  }
              }
            }

        }        
        resolve(errorMsg)
    })
    
  }

  const validateRaters = () => {
    return new Promise(async (resolve) => {
      let subjects = formik.values.subjects
      console.log("validateRaters----------------")
      let error = false;
      for(let i = 0; subjects.length > i; i++){
        // console.log("subjects[i].subject_raters",subjects[i].subject_raters)
        // if((!subjects[i].subject_raters) || (subjects[i]?.subject_raters && subjects[i].subject_raters.length === 0) || await checkRaters(i) !== ''){
        let check = await checkRaters(i)
        console.log("check",check)
        if(check){
          console.log("check11",check)
          error = true
          setIsLoading(false)
          setIsErrorNoOfRaterGroup(true)
          resolve(error)
        }
      }
      console.log("erro1r",error)
      
      resolve(error)
    })
    

    // const managerGroup = groups.find(group => group.name === 'Manager');
    // const managerGroupId = managerGroup.id;
    // console.log("managerGroupId", managerGroupId)
    // for (let i = 0; i < raters.length; i++) {
    //     const rater = raters[i];
    //     console.log("rater.groupId",rater.groupId)
    //     if (parseInt(rater.groupId) !== parseInt(managerGroupId)) {
    //         const count = raters.filter(r => r.groupId === rater.groupId).length;
    //         if (count < 3) {
    //             return false;
    //         }
    //     }
    // }
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const saveData1 = () => {
    axios.post("/api/createAssessment", formik.values).then(res => {
      if(res.data.success){
        let currStep = activeStep
        setActiveStep((prevActiveStep) => prevActiveStep + 1)
        if(currStep === 0){
          navigate('/create_assessment/'+res.data.assessmentId)
          setIsLoading(false)
        }
        else{
          getDetails()
        }        
      } 
      else{
          // Swal.fire(res.data.message, '', 'error')
      }
    }).catch((error) => {
      // Swal.fire(error.response.data.message, '', 'error')
    });
  }
  const normalizeString = (value) => {
    if (!value) return '';
    return value.trim().replace(/\s+/g, ' ');
  };

  const saveData = async () => {
    try {
      setIsLoading(true);

      const formData = new FormData();

      // ===== NORMAL FIELDS =====
      formData.append("id", formik.values.id);
      // formData.append("name", formik.values.name);
      formData.append("name", normalizeString(formik.values.name));
      formData.append("scalePoint", formik.values.scalePoint);
      formData.append("measurementType", formik.values.measurementType);
      formData.append("templateType", formik.values.templateType);
      formData.append("template", formik.values.template);

      // ===== OBJECTS (send only ID) =====
      if (formik.values.team) {
        formData.append("team", JSON.stringify(formik.values.team));
      }

      if (formik.values.emailTemplate) {
        formData.append("emailTemplate", JSON.stringify(formik.values.emailTemplate));
      }

      if (formik.values.survey) {
        formData.append("survey", formik.values.survey);
      }

      // ===== ARRAYS =====
      formData.append("questions", JSON.stringify(formik.values.questions));
      formData.append("raterGroups", JSON.stringify(formik.values.raterGroups));
      formData.append("subjects", JSON.stringify(formik.values.subjects));

      // ===== LOGOS (IMPORTANT) =====
      if (formik.values.logo1 instanceof File) {
        // console.log("logo1:", formik.values.logo1);
        // console.log("is File:", formik.values.logo1 instanceof File);
        
        formData.append("logo1", formik.values.logo1);
      }

      // const formDataObj = {};
      // for (let [key, value] of formData.entries()) {
      //   formDataObj[key] = value;
      // }
      // console.log("FormData:", formDataObj);
      
      // return false;

      const res = await axios.post(
        "/api/createAssessment",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          transformRequest: (data) => data, // 🔥 IMPORTANT
        }
      );

      if (res.data.success) {
        let currStep = activeStep;

        setActiveStep((prev) => prev + 1);

        if (currStep === 0) {
          navigate("/create_assessment/" + res.data.assessmentId);
        } else {
          getDetails();
        }
      }

    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  // const handleSkip = () => {
  //   if (!isStepOptional(activeStep)) {
  //     // You probably want to guard against something like this,
  //     // it should never occur unless someone's actively trying to break something.
  //     throw new Error("You can't skip a step that isn't optional.");
  //   }

  //   setActiveStep((prevActiveStep) => prevActiveStep + 1);
  //   setSkipped((prevSkipped) => {
  //     const newSkipped = new Set(prevSkipped.values());
  //     newSkipped.add(activeStep);
  //     return newSkipped;
  //   });
  // };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <Layout>
        <Header pageTitle={'Send Assessment'} />
        <div className="container-xxl flex-grow-1 container-p-y">
            <Box sx={{ width: '100%' }}>
                <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                    {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
                    </Step>
                    ))}
                </Stepper>
                {/* <Stepper activeStep={activeStep}>
                    {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    if (isStepOptional(index)) {
                        labelProps.optional = (
                        <Typography variant="caption">Optional</Typography>
                        );
                    }
                    if (isStepSkipped(index)) {
                        stepProps.completed = false;
                    }
                    return (
                        <Step key={label} {...stepProps}>
                        <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                    );
                    })}
                </Stepper> */}
                {activeStep === steps.length ? (
                    <React.Fragment>
                        <Typography sx={{ mt: 2, mb: 1 }}>
                            All steps completed - you&apos;re finished
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                            <Box sx={{ flex: '1 1 auto' }} />
                            <Button onClick={handleReset}>Reset</Button>
                        </Box>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        
                        {
                            activeStep === 0 ?
                            <Create formik={formik}/>
                            : activeStep === 1 ? 
                            <SelectCompetencies formik={formik}/>
                            : activeStep === 2 ? 
                            <AddRaterGroups formik={formik} />
                            : activeStep === 3 ? 
                            <AddSubjects formik={formik}/>
                            : activeStep === 4 ?
                            <AddRaters formik={formik} isErrorNoOfRaterGroup={isErrorNoOfRaterGroup} setIsErrorNoOfRaterGroup={setIsErrorNoOfRaterGroup}/> 
                            : activeStep === 5 ?
                            <SendToOrg formik={formik}/>
                            : activeStep === 6 ?
                            <SendToSubjects formik={formik}/>
                            :
                            <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography>
                        }
                        {
                          isLoading === true ?
                          <div style={{textAlign: 'right'}}>
                            <CircularProgress />
                          </div>
                          
                          :
                          <Box sx={{ display: 'flex', flexDirection: 'row', float:'right', pt: 2 }}>
                            <Button
                              color="inherit"
                              disabled={activeStep === 0}
                              onClick={handleBack}
                              sx={{ mr: 1 }}
                              className='btn bg_color text-white'
                              >
                              Back
                            </Button>
                            <Box sx={{ flex: '1 1 auto' }} />
                              {/* {isStepOptional(activeStep) && (
                              <Button className='btn btn-primary text-white' color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                                  Skip
                              </Button>
                              )} */}
                            {
                              activeStep === steps.length - 1 ? '' :
                              <Button className='btn btn-primary text-white' onClick={handleNext}>
                                Save & Next
                              </Button>
                            }                            
                          </Box>
                        }
                        
                    </React.Fragment>
                )}
            </Box>
        </div>
    </Layout>
  );
}
